module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.files.length > 0) ? _c('v-row', _vm._l((_vm.files), function(item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "3",
        "lg": "3",
        "align": "center"
      }
    }, [(item.type.indexOf('image') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [_c('v-card', {
            staticClass: "d-flex",
            attrs: {
              "flat": "",
              "tile": "",
              "elevation": hover ? 16 : 2
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": item.url,
              "lazy-src": item.url,
              "aspect-ratio": "1"
            }
          })], 1)]
        }
      }], null, true)
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('pdf') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/pdf.png",
        "aspect-ratio": "1"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/ppt.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/doc.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/text.png"
      }
    })], 1) : _vm._e()])
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-713ee89b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/custom/FilePreview.vue
// module id = 2189
// module chunks = 0